import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: () => import('../page/index')
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('../page/about')
    },
    {
      path: '/product',
      name: 'product',
      component: () => import('../page/product')
    },
    {
      path: '/product/productInfo',
      name: 'productInfo',
      component: () => import('../page/productInfo')
    },
    {
      path: '/product/productInfo/productItem',
      name: 'productItem',
      component: () => import('../page/productItem')
    },
    {
      path: '/news',
      name: 'news',
      component: () => import('../page/news')
    },
    {
      path: '/news/description',
      name: 'description',
      component: () => import('../page/description')
    },
    {
      path: '/recruit',
      name: 'recruit',
      component: () => import('../page/recruit')
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('../page/contact')
    },
    {
      path: '/newRecommend',
      name: 'newRecommend',
      component: () => import('../page/newRecommend')
    },
    {
      path: '/newRecommend/descriptionRecoment',
      name: 'descriptionRecoment',
      component: () => import('../page/descriptionRecoment')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js